import React, { useState } from "react";

export default function LoginSettings() {
  const [themeColor, setThemeColor] = useState("#000080");
  const [imagePreview, setImagePreview] = useState(null);

  const handleColorChange = (e) => {
    setThemeColor(e.target.value);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-6">Login Page Settings</h2>

      {/* Image Upload */}
      <div className="mb-6">
        <label className="block mb-2 font-medium">Left-Side Login Image</label>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {imagePreview && (
          <img
            src={imagePreview}
            alt="Preview"
            className="mt-4 w-48 h-auto border rounded"
          />
        )}
      </div>

      {/* Colour Picker + HEX input */}
      <div className="mb-6">
        <label className="block mb-2 font-medium">Banner & Button Colour</label>
        <div className="flex items-center space-x-4">
          <input
            type="color"
            value={themeColor}
            onChange={handleColorChange}
            className="w-12 h-12 border rounded"
          />
          <input
            type="text"
            value={themeColor}
            onChange={handleColorChange}
            className="px-3 py-2 border rounded text-sm"
            placeholder="#000080"
          />
        </div>
      </div>

      {/* Preview Button */}
      <div className="mt-8">
        <button
          style={{ backgroundColor: themeColor }}
          className="text-white px-6 py-2 rounded shadow hover:opacity-90 transition"
        >
          Save Settings
        </button>
      </div>
    </div>
  );
}
